module.exports = __webpack_public_path__ + "static/img/icon-05.52c805d6.png";